import { render, staticRenderFns } from "./InventoryBack.vue?vue&type=template&id=48b73527&"
import script from "./InventoryBack.vue?vue&type=script&lang=js&"
export * from "./InventoryBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports